import { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { useMutation, useQuery } from "react-query";
import axios from "axios";
import Config from "../../Config";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import AddDuesModal from "../../Components/Dues/AddDuesModal";
import moment from "moment";
import Passbook from "../../Components/Tenants/Details/Passbook";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import TenantInfo from "../../Components/Tenants/Details/TenantInfo";
import Documents from "../../Components/Tenants/Details/Documents";
import Menu from "../../Components/Tenants/Details/Menu";
import { TenantDetailsLoading } from "../../Components/SkeletonLoading";
import { capitalizeFirstLetter, getMoveOutReasonLabel, getOrdinalNumber, hasPermission } from "../../helpers";
import { BoxContainer, FloorTabs } from "../../Components/Styles/PageStyles";
import MarkAsPaidModal from "../../Components/Dues/MarkAsPaidModel";
import InitiateTenantEviction from "../../Components/Dues/InitiateTenantEviction";
import EvictNowModal from "../../Components/Tenants/Details/EvictNowModal";
import CancelEviction from "../../Components/Tenants/Details/CancelEviction";
import EditDuesModel from "../../Components/Dues/EditDuesModel";
import ViewDueDetails from "../../Components/Dues/ViewDetail";
import RestorePayment from "../../Components/Transactions/RestorePayment";
import ChangeRoom from "../../Components/Tenants/Details/ChangeRoom";
import CancelReservation from "../../Components/Tenants/Details/CancelReservation";
import MarkAsPaidAllDue from "../../Components/Dues/MarkAsPaidAllDue";
import ChangeRentalCycle from "../../Components/Tenants/Details/ChangeRentalCycle";
import OfflineRefundModal from "../../Components/Dues/OfflineRefundModal";
import OnlineRefundModal from "../../Components/Dues/OnlineRefundModal";
import {
  FaCheck,
  FaSpinner
} from "react-icons/fa";
import ViewModal from "../../Components/Transactions/ViewModal";
import ExtendStay from "../../Components/Tenants/Details/ExtendStay";
import SideModal from "../../Components/SideModal";
import Images from "../../Images";
import ActivityLogs from "./Detail/ActivityLogs";
import PaymentLinkModal from "../../Components/PaymentLinkModal";
import { getPaymentLinkAndQr } from "../../utilities/paymentLink.api";
import FnFModal from "../../Components/Tenants/FnFModal";
import ReassignTenant from "../../Components/AddTenant/ReassignTenant";
import ViewFinalDues from "../../Components/Tenants/ViewFinalDues";
import DeleteTenantModal from "../../Components/Tenants/Details/DeleteTenantModal";
import Notes from "../../Components/Tenants/Notes";
import Ledger from "./Detail/Ledger";
import { FiCalendar, FiArrowLeft } from "react-icons/fi";
import ChangeOccupancyModal from "../../Components/Tenants/Details/ChangeOccupancyModal";
import AddCommission from "../../Components/StaffCommission/AddCommission";
import ViewCommissionModal from "../../Components/StaffCommission/ViewCommissionModal";
import MarkAsPaidStaffCommission from "../../Components/StaffCommission/MarkAsPaidStaffCommission";
import EntireRoomOccupancy from "../../Components/Tenants/Details/EntireRoomOccupancy";
import useVerifyBankAccount from "../../utilities/useVerifyBankAccount";
import WifiPasswordModal from "../../Components/Tenants/Details/WiFiPasswordModal";

const TenantDetails = () => {
  const navigate = useNavigate();
  const property = useSelector((state) => state.PropertyReducer.property);
  const [wifiListData, setWifiListData] = useState(null);
  const [showNotesModal, setShowNotesModal] = useState(false);
  const { id: paramId, t: reqType, e } = useParams();
  const user = useSelector((state) => state.UserReducer.user);
  const location = useLocation();
  const [selectedData, setSelectedData] = useState("");
  const [showUploadModel, setShowUploadModel] = useState(false);
  const [isMarkAsPaidVisible, setIsMarkAsPaidVisible] = useState(false);
  const [isReturnDeposit, setIsReturnDeposit] = useState(false);
  const [showOnlineRefundModal, setShowOnlineRefundModal] = useState(false);
  const [showOfflineRefundModal, setShowOfflineRefundModal] = useState(false);
  const [isMarkAsPaidAllDue, setIsMarkAsPaidAllDue] = useState(false);
  const [initiateEviction, setInitiateEviction] = useState(false);
  const [isChangeRoom, setIsChangeRoom] = useState(false);
  const [isEvictNow, setIsEvictNow] = useState(false);
  const [isCancelEviction, setIsCancelEviction] = useState(false);
  const [isCancelReservation, setIsCancelReservation] = useState(false);
  const [isExtendStay, setIsExtendStay] = useState(false);
  const [isRentalCycle, setIsRentalCycle] = useState(false);
  const [addDues, setAddDues] = useState(false);
  const [isAddDuesModal, setIsAddDuesModal] = useState(false);
  const [activeStep, setActiveStep] = useState("Tenant Info");
  const [goTo, setGoto] = useState(location?.state?.tabKey || "totalDues");
  const [apiData, setApiData] = useState();
  const [docs, setDocs] = useState([]);
  const [selfi, setSelfi] = useState(null);
  const [tenantId, setTenantId] = useState(0);
  const [rentStartDate, setRentStartDate] = useState("");
  const [isRestorePayment, setIsRestorePayment] = useState(false);
  const [isEditDue, setIsEditDues] = useState(false);
  const [isShowDueDetails, setShowDueDetails] = useState(false);
  const [viewDetail, setViewDetail] = useState(false);
  const [showPaymentLinkModal, setShowPaymentLinkModal] = useState(false);
  const [paymentData, setPaymentData] = useState(null);
  const [loadingId, setLoadingId] = useState(null);
  const [showFnFModal, setShowFnFModal] = useState(false);
  const [isReassignTenant, setIsReassignTenant] = useState(false);
  const [isShowFinalDuesModal, setIsShowFinalDuesModal] = useState(false);
  const [fnfData, setFnfData] = useState(null);
  const [isDeleteTenantModal, setIsDeleteTenantModal] = useState(false);
  const [isViewNotes, setIsViewNotes] = useState(false);
  const [isChangeOccupancy, setIsChangeOccupancy] = useState(false);
  const [isEntireOccupancy, setIsEntireOccupancy] = useState(false);
  const [isCommissionModal, setIsCommissionModal] = useState(false);
  const [isViewCommissionModal, setIsViewCommissionModal] = useState(false);
  const [isPayCommissionModal, setIsPayCommissionModal] = useState(false);
  const [selectedStaff, setSelectedStaff] = useState("");
  const [isEditOccupancy, setIsEditOccupancy] = useState(false);
  const [isWifiPassword, setIsWifiPassword] = useState(false);

  const steps = ["Tenant Info", "Passbook", "Ledger", "Documents", "Activity Logs"];

  // const canSettleDues =
  //   user?.userType === Config.USER_TYPE.CLIENT || user?.role === Config.USER_TYPE.PARTNER ||
  //   (user?.userType === Config.USER_TYPE.STAFF &&
  //     user?.role === Config.STAFF_ROLES.ADMIN) ||
  //   (user?.userType === Config.USER_TYPE.STAFF &&
  //     user?.role === Config.STAFF_ROLES.WARDEN);
  const canSettleDues = hasPermission("MANANGE_EDIT_DUES", user);

  const [hideLoadingId, setHideLoadingId] = useState(null);
  const query = `/tenant/details/web/${paramId}?t=&e=${e}`
  const tabName = location?.state?.tabName || "Tenant Info";

  const fetchFunction = async () => {
    const response = await axios.get(`${Config.apiUrl}${query}`, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
    return response.data;
  };

  const getSuccess = (res) => {
    if (res.data === false) error = true;
    else {
      setTenantId(res?.data?.id);
      setApiData(res?.data);
      setDocs(res?.data?.docs);
      setRentStartDate(res?.data?.rentStartDate);
      const selfi = res?.data?.docs?.find((tenant) => tenant.type === 4);
      setSelfi(selfi?.value || null);
    }
  };

  const getError = (res) => { };

  const {
    isLoading,
    mutate: getListMutate,
    error,
    data,
    isRefetching,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  useEffect(() => {
    getListMutate();
  }, []);

  const handleButtonClick = (step) => {
    setActiveStep(step);
  };

  const canHideDues = data?.data?.canHideDues
  const hasDues = Number(data?.data?.totalDues) > 0;

  const editRentDetailFunction = async (values) => {
    const payload = {
      tenantId: tenantId,
      rent: Number(values.rent),
      security: Number(values.security),
      moveInDate: moment(values.moveInDate).format("YYYY-MM-DD"),
      moveOutDate: values.occupiedMoveOutDate ? moment(values.occupiedMoveOutDate).format("YYYY-MM-DD") : null,
      rentalCycle: values.rentalCycle,
      agreementPeriod: Number(values.agreementPeriod),
      lockInPeriod: Number(values.lockInPeriod),
      noticePeriod: Number(values.noticePeriod),
      rentalType: Number(values.rentalType),
      isOnlinePaymentEnabled: Number(values.isOnlinePaymentEnabled),
      bondAllowed: values.rentalBond,
      notes: values.notes,
      bookedBy: values.bookedBy
      // agreementStartDate: moment(values.agreementStartDate).format("YYYY-MM-DD"),
    };
    return await axios.post(
      `${Config.apiUrl}/tenant/update/rent/details/web
`,
      payload,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/json",
        },
      }
    );
  };

  const editRentDetailSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Rent Details successfully Updated.");
    } else {
      toast.success(data?.data?.msg || "Fail to update Rent Details");
    }
  };

  const editRentDetailError = (res) => { };

  const { isLoading: isRentDetailLoading, mutate: editRentDetailMutate } =
    useMutation(editRentDetailFunction, {
      onSuccess: editRentDetailSuccess,
      onError: editRentDetailError,
    });

  const editPersonalDetailFunction = async (values) => {
    const payload = {
      tenantId: tenantId,
      name: values.name,
      mobile: Number(values.mobile),
      email: values.email,
      gender: values.gender,
      dob: values.dob ? moment(values.dob).format("YYYY-MM-DD") : null,
      address: values.address,
      nationality: values.nationality,
      alternateMobile:
        values.alternateMobile === 0 ? "" : values.alternateMobile,
      monthlyIncome: Number(values.monthlyIncome),
      bloodGroup: Number(values.bloodGroup),
    };

    return await axios.post(
      `${Config.apiUrl}/tenant/update/personal/details
`,
      payload,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/json",
        },
      }
    );
  };

  const editPersonalDetailSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Tenant Info successfully Updated.");
    } else {
      toast.success(data?.data?.msg || "Fail to update Tenant Info");
    }
  };

  const editPersonalDetailError = (res) => { };

  const {
    isLoading: isPersonalDetailLoading,
    mutate: editPersonalDetailMutate,
  } = useMutation(editPersonalDetailFunction, {
    onSuccess: editPersonalDetailSuccess,
    onError: editPersonalDetailError,
  });

  // Function to handle Guardian Detail form submission
  const editGuardianDetailFunction = async (values) => {
    const payload = {
      tenantId: tenantId,
      fatherName: values.fatherName,
      fatherMobile: values.fatherMobile,
      fatherOccupation: values.fatherOccupation,
      fatherAnnualIncome: Number(values.fatherAnnualIncome),
      motherName: values.motherName,
      motherMobile: values.motherMobile,
      localGuardianName: values.localGuardianName,
      localGuardianMobile: values.localGuardianMobile,
      localGuardianRelation: Number(values.localGuardianRelation),
    };
    return await axios.post(
      `${Config.apiUrl}/tenant/update/guardian/details`,
      payload,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/json",
        },
      }
    );
  };

  const getGuardianDetailSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Tenant Info successfully Updated.");
    }
  };

  const getGuardianDetailError = (res) => { };

  const {
    isLoading: isGuardianDetailLoading,
    mutate: addGuardianDetailMutate,
  } = useMutation(editGuardianDetailFunction, {
    onSuccess: getGuardianDetailSuccess,
    onError: getGuardianDetailError,
  });

  // Function to handle Occupation Detail form submission
  const editOccupationDetailFunction = async (values) => {
    const payload = {
      tenantId: tenantId,
      institutionEmail: values.institutionEmail,
      institutionName: values.institutionName,
      title: values.courseName,
      occupation: values.occupation,
    };

    return await axios.post(
      `${Config.apiUrl}/tenant/update/occupation/details`,
      payload,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/json",
        },
      }
    );
  };

  const getOccupationDetailSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Tenant Info successfully Updated.");
    }
  };

  const getOccupationDetailError = (res) => { };

  const {
    isLoading: isOccupationDetailLoading,
    mutate: editOccupationDetailMutate,
  } = useMutation(editOccupationDetailFunction, {
    onSuccess: getOccupationDetailSuccess,
    onError: getOccupationDetailError,
  });

  const getTenantState = (e) => {
    if (apiData?.occupancy?.status === Config.OCCUPANCY_STATUS.RESERVED) {
      return <Reserved>Reserved</Reserved>;
    }
    if (
      !e &&
      Config.OCCUPANCY_STATUS.MOVING_OUT !== apiData?.occupancy?.status
    ) {
      return <Active>Active</Active>;
    } else if (
      !e &&
      Config.OCCUPANCY_STATUS.MOVING_OUT === apiData?.occupancy?.status
    ) {
      return <InActive>Moving Out</InActive>;
    } else {
      return <InActive>InActive</InActive>;
    }
  };

  useEffect(() => {
    setActiveStep(tabName);
  }, [tabName]);

  //------- Upload Document -------
  const uploadDocumentFunction = async (data) => {
    const formData = new FormData();
    formData.append("tenantId", tenantId);
    formData.append("type", data.type);
    formData.append("files", data.selectedDoc);
    return await axios.post(
      `${Config.apiUrl}/client/kyc/upload/document`,
      formData,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
  };

  const onUploadDocSuccess = (data) => {
    setShowUploadModel(false);
    if (data?.data?.isSuccess === true) {
      setDocs(data?.data?.docs);
      toast.success(data?.data?.msg || "Success");
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onUploadDocError = (data) => {
    setShowUploadModel(false);
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: isDocLoading, mutate: uploadDocMutate } = useMutation(
    uploadDocumentFunction,
    {
      onSuccess: onUploadDocSuccess,
      onError: onUploadDocError,
    }
  );

  //------- Mark as Paid Model -------
  const MarkAsPaidFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/due/paid/with/receipt`, values, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${user.token}`,
      },
    });
  };

  const markAsPaidSuccess = (data) => {
    setIsMarkAsPaidVisible(false);
    getListMutate();
    toast.success(data?.data?.msg || "Success");
  };

  const markAsPaidError = (data) => {
    setIsMarkAsPaidVisible(false);
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: markAsPaidLoading, mutate: markAsPaidMutate } =
    useMutation(MarkAsPaidFunction, {
      onSuccess: markAsPaidSuccess,
      onError: markAsPaidError,
    });

  //------- Mark as Paid All Due Model -------
  const MarkAsPaidAllDueFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/due/paid/all/new`, values, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${user.token}`,
      },
    });
  };

  const markAsPaidAllDueSuccess = (data) => {
    setIsMarkAsPaidAllDue(false);
    getListMutate();
    toast.success(data?.data?.msg || "Success");
  };

  const markAsPaidAllDueError = (data) => {
    setIsMarkAsPaidAllDue(false);
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: markAsPaidAllDueLoading, mutate: markAsPaidAllDueMutate } =
    useMutation(MarkAsPaidAllDueFunction, {
      onSuccess: markAsPaidAllDueSuccess,
      onError: markAsPaidAllDueError,
    });

  //------- Mark as Paid All Due Model -------
  const ReturnDepositFunction = async (values) => {
    return await axios.post(
      `${Config.apiUrl}/due/settle/excess/after/eviction`,
      values,
      {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${user.token}`,
        },
      }
    );
  };

  const returnDepositSuccess = (data) => {
    setShowOfflineRefundModal(false);
    setIsShowFinalDuesModal(false)
    getListMutate();
    toast.success(data?.data?.msg || "Success");
  };

  const returnDepositError = (data) => {
    setShowOfflineRefundModal(false);
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: returnDepositLoading, mutate: returnDepositMutate } =
    useMutation(ReturnDepositFunction, {
      onSuccess: returnDepositSuccess,
      onError: returnDepositError,
    });

  //------- Add Due Model -------
  const AddDueFunction = async (values) => {
    // return await axios.post(`${Config.apiUrl}/due/add/new`, values, {
    return await axios.post(`${Config.apiUrl}/due/add/with/images`, values, {
      headers: {
        // "Content-Type": "application/json",
        // authorization: `Bearer ${user.token}`,
        authorization: `Bearer ${user.token}`,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const addDueSuccess = (data) => {
    if (isShowFinalDuesModal && isAddDuesModal) {
      dueListReftech()
    }
    else if (isAddDuesModal) {
      getListMutate();
    }
    setIsAddDuesModal(false);
    toast.success(data?.data?.msg || "Success");
  };

  const addDueError = (data) => {
    setAddDues(false);
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: addDuesLoading, mutate: addDuesMutate } = useMutation(
    AddDueFunction,
    {
      onSuccess: addDueSuccess,
      onError: addDueError,
    }
  );

  //------- Cancel Eviction Model -------
  const CancelEvictionFunction = async (values) => {
    return await axios.post(
      `${Config.apiUrl}/client/tenant/remove/cancel`,
      values,
      {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${user.token}`,
        },
      }
    );
  };

  const cancelEvictionSuccess = (data) => {
    getListMutate();
    setIsCancelEviction(false);
    toast.success(data?.data?.msg || "Success");
  };

  const cancelEvictionError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: cancelEvictionLoading, mutate: cancelEvictionMutate } =
    useMutation(CancelEvictionFunction, {
      onSuccess: cancelEvictionSuccess,
      onError: cancelEvictionError,
    });

  //------- Cancel Reservation Model -------
  const CancelReservationFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/tenant/reserve/cancel`, values, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${user.token}`,
      },
    });
  };

  const cancelReservationSuccess = (data) => {
    navigate("/tenants/active");
    setIsCancelReservation(false);
    toast.success(data?.data?.msg || "Success");
  };

  const cancelReservationError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const {
    isLoading: cancelReservationLoading,
    mutate: cancelReservationMutate,
  } = useMutation(CancelReservationFunction, {
    onSuccess: cancelReservationSuccess,
    onError: cancelReservationError,
  });

  //------- Evict Now Model -------
  const evictNowFunction = async (values) => {
    return await axios.post(
      `${Config.apiUrl}/client/tenant/remove/now`,
      values,
      {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${user.token}`,
        },
      }
    );
  };

  const evictNowSuccess = (data) => {
    navigate("/tenants/moved-out");
    toast.success(data?.data?.msg || "Success");
  };

  const evictNowError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: evictNowLoading, mutate: evictNowMutate } = useMutation(
    evictNowFunction,
    {
      onSuccess: evictNowSuccess,
      onError: evictNowError,
    }
  );

  //------- Edit Dues Function -------
  const editDuesFunction = async (values) => {
    const payload = {
      dueId: values.id,
      newAmount: Number(values.balance),
      isTemp: false,
      tenantId: tenantId,
      isEvicted: e ? true : false,
    };

    return await axios.post(`${Config.apiUrl}/due/edit/new`, payload, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };

  const onEditDueSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      if (isEditDue) {
        getListMutate();
      }
      if (isShowFinalDuesModal) {
        dueListReftech();
      }

    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
    setSelectedData("");
    setIsEditDues(false);
  };

  const onEditDueError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: editDueLoading, mutate: editDuesMutate } = useMutation(
    editDuesFunction,
    {
      onSuccess: onEditDueSuccess,
      onError: onEditDueError,
    }
  );

  //------- Send Reminder Function -------
  const sendReminderFunction = async (values) => {
    const payload = {
      tenantId: values.tenantId,
    };
    //return;
    return await axios.post(
      `${Config.apiUrl}/client/reminded-tenant/`,
      payload,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/json",
        },
      }
    );
  };

  const onSendReminderSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
    setSelectedData("");
  };

  const onSendReminderError = (data) => {
    setSelectedData("");
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: sendReminderLoading, mutate: sendReminderMutate } =
    useMutation(sendReminderFunction, {
      onSuccess: onSendReminderSuccess,
      onError: onSendReminderError,
    });

  //------- Add/Edit Remark Model -------
  const AddEditRemarkFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/due/set/remarks`, values, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${user.token}`,
      },
    });
  };

  const addEditRemarkSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg);
      setShowNotesModal(false);
      setShowDueDetails(false);
      getListMutate();
    } else {
      toast.success(data?.data?.msg);
    }
  };

  const addEditRemarkError = (data) => {
    // setIsMarkAsPaidVisible(false);
    // toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: addEditRemarkLoading, mutate: addEditRemarkMutate } =
    useMutation(AddEditRemarkFunction, {
      onSuccess: addEditRemarkSuccess,
      onError: addEditRemarkError,
    });

  //------- Restore Payment -------
  const RestorePaymentFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/transaction/restore`, values, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${user.token}`,
      },
    });
  };

  const restorePaymentSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg);
      setIsRestorePayment(false);
      getListMutate();
    } else {
      toast.success(data?.data?.msg);
    }
  };

  const restorePaymentError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: restorePaymentLoading, mutate: restorePaymentMutate } =
    useMutation(RestorePaymentFunction, {
      onSuccess: restorePaymentSuccess,
      onError: restorePaymentError,
    });

  //------- Change Rental cycle Model -------
  const ChangeRentalCycleFunction = async (values) => {
    return await axios.post(
      `${Config.apiUrl}/tenant/change/rental/cycle`,
      values,
      {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${user.token}`,
        },
      }
    );
  };

  const changeRentalCycleSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg);
      setIsRentalCycle(false);
      getListMutate();
    } else {
      toast.success(data?.data?.msg);
    }
  };

  const changeRentalCycleError = (data) => { };

  const {
    isLoading: changeRentalCycleLoading,
    mutate: changeRentalCycleMutate,
  } = useMutation(ChangeRentalCycleFunction, {
    onSuccess: changeRentalCycleSuccess,
    onError: changeRentalCycleError,
  });

  //------- Extend Stay Model -------
  const ExtendStayFunction = async (values) => {
    return await axios.post(
      `${Config.apiUrl}/client/tenant/extend/stay`,
      values,
      {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${user.token}`,
        },
      }
    );
  };

  const extendStaySuccess = (data) => {
    navigate("/tenants/active");
    setIsExtendStay(false);
    toast.success(data?.data?.msg || "Success");
  };

  const extendStayError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: extendStayLoading, mutate: extendStayMutate } =
    useMutation(ExtendStayFunction, {
      onSuccess: extendStaySuccess,
      onError: extendStayError,
    });
  const handleExtendStayClose = () => {
    setIsExtendStay(false);
  };

  const loadPaymentLinkModal = async (dueId, e) => {
    setLoadingId(dueId); // start loader for this row
    const res = await getPaymentLinkAndQr(user.token, dueId, e);
    setLoadingId(null);
    if (!res.success) {
      toast.error(res.error);
      return;
    }

    if (res.paymentLink) {
      setPaymentData(res);
      setShowPaymentLinkModal(true);
    }
    else {
      const encodedMsg = encodeURIComponent(res.reminderText);
      const url = `https://wa.me/+91${res.mobile}?text=${encodedMsg}`;
      window.open(url, "_blank"); // Opens WhatsApp in a new tab
    }
  };

  const generateFnFQuery = useQuery({
    queryKey: ['fnfData', tenantId],
    queryFn: async () => {
      const url = `${Config.apiUrl}/tenant/get/final/breakdown?tenantId=${tenantId}&sendFnF=0`;
      const response = await axios.get(url, {
        headers: {
          authorization: `Bearer ${user.token}`,
          "Content-Type": "application/json",
        },
      });

      const res = response?.data;
      if (!res?.isSuccess) {
        throw new Error(res?.msg || "Something went wrong");
      }

      return {
        link: res.link,
        tenantMobile: res.tenantMobile,
        message: res.msg,
        sent: false
      };
    },
    enabled: false,
    retry: false,
  });

  const sendFnFMutation = useMutation({
    mutationFn: async () => {
      const url = `${Config.apiUrl}/tenant/get/final/breakdown?tenantId=${tenantId}&sendFnF=1`;
      const response = await axios.get(url, {
        headers: {
          authorization: `Bearer ${user.token}`,
          "Content-Type": "application/json",
        },
      });

      const res = response?.data;
      if (!res?.isSuccess) {
        throw new Error(res?.msg || "Something went wrong");
      }

      return res;
    },
    onSuccess: (data) => {
      toast.success(data?.msg || "FnF sent to tenant successfully");
      setFnfData(prev => ({
        ...prev,
        sent: true
      }));
    },
    onError: (error) => {
      toast.error(error.message || "Failed to send FnF");
    },
  });

  const handleSubmitFinalDues = async () => {
    try {
      const result = await generateFnFQuery.refetch();

      if (result.data) {
        setFnfData(result.data);
        setIsShowFinalDuesModal(false);
        getListMutate()
        setShowFnFModal(true);
      }
    } catch (error) {
      toast.error("Failed to generate final statement");
    }
  };
  const handleSubmitFinalDuesSummary = async () => {
    try {
      const result = await generateFnFQuery.refetch();

      if (result.data) {
        setFnfData(result.data);
        setIsShowFinalDuesModal(false);
        setShowFnFModal(true);
      }
    } catch (error) {
      toast.error("Failed to generate final statement");
    }
  };

  const handleSendToTenant = () => {
    if (fnfData) {
      sendFnFMutation.mutate();
    }
  };

  const handleFnFClose = () => {
    setShowFnFModal(false);
  };

  const handleReassignClose = () => {
    setIsReassignTenant(false);
  };

  const handleCommissionModal = () => {
    setIsCommissionModal(false);
  };

  const handleViewCommissionModal = () => {
    setIsViewCommissionModal(false);
  };

  const handlePayCommissionModal = () => {
    setIsPayCommissionModal(false);
  };

  const fetchDueFinalListing = async () =>
    await axios.get(`${Config.apiUrl}/due/tenant/final/statement?tenantId=${tenantId}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${user.token}`,
      },
    });

  const { isLoading: dueListLoading, error: dueListError, data: dueListData, refetch: dueListReftech } = useQuery(
    ['dueData', tenantId],
    fetchDueFinalListing,
    {
      enabled: isShowFinalDuesModal,
    }
  );

  //------- Reassign Tenant Model -------
  const ReassignTenantFunction = async (values) => {
    return await axios.post(
      `${Config.apiUrl}/tenant/book/again`,
      values,
      {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${user.token}`,
        },
      }
    );
  };

  const reassignTenantSuccess = (data) => {
    navigate("/tenants/active");
    setIsReassignTenant(false);
    toast.success(data?.data?.msg || "Success");
  };

  const reassignTenantError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: reassignTenantLoading, mutate: reassignTenantMutate } =
    useMutation(ReassignTenantFunction, {
      onSuccess: reassignTenantSuccess,
      onError: reassignTenantError,
    });

  //------- Hide Due Model -------
  const {
    isLoading: hideDueLoading,
    mutate: hideDueMutate,
  } = useMutation(
    (payload) =>
      axios.post(`${Config.apiUrl}/due/toggle`, payload, {
        headers: {
          authorization: `Bearer ${user.token}`,
        },
      }),
    {
      onSettled: () => {
        setIsEditDues(false);
      },
      onSuccess: ({ data }) => {
        getListMutate();
        toast.success(data?.msg || 'Success');
      },
      onError: (error) => {
        toast.error(error?.response?.data?.msg || 'An error occurred');
      },
    }
  );

  //------- Delete Tenant Model -------
  const {
    isLoading: deleteTenantLoading,
    mutate: deleteTenantMutate,
  } = useMutation(
    (payload) =>
      axios.post(`${Config.apiUrl}/client/delete/tenant`, payload, {
        headers: {
          authorization: `Bearer ${user.token}`,
        },
      }),
    {
      onSettled: () => {
        setIsDeleteTenantModal(false);
      },
      onSuccess: ({ data }) => {
        navigate("/tenants/active");
        toast.success(data?.msg || 'Success');
      },
      onError: (error) => {
        toast.error(error?.response?.data?.msg || 'An error occurred');
      },
    }
  );

  //------- Change Occupancy Model -------
  const {
    isLoading: changeOccupancyLoading,
    mutate: changeOccupancyMutate,
  } = useMutation(
    (payload) =>
      axios.post(`${Config.apiUrl}/client/update/occupancy`, payload, {
        headers: {
          authorization: `Bearer ${user.token}`,
        },
      }),
    {
      onSettled: () => {
        setIsChangeOccupancy(false);
      },
      onSuccess: ({ data }) => {
        getListMutate();
        toast.success(data?.msg || 'Success');
      },
      onError: (error) => {
        toast.error(error?.response?.data?.msg || 'An error occurred');
      },
    }
  );

  //------- Change Entire Room Occupancy Model -------
  const {
    isLoading: entireRoomOccupancyLoading,
    mutate: entireRoomOccupancyMutate,
  } = useMutation(
    (payload) =>
      axios.post(`${Config.apiUrl}/client/update/occupancy/fully`, payload, {
        headers: {
          authorization: `Bearer ${user.token}`,
        },
      }),
    {
      onSettled: () => {
        setIsEntireOccupancy(false);
      },
      onSuccess: ({ data }) => {
        getListMutate();
        toast.success(data?.msg || 'Success');
      },
      onError: (error) => {
        toast.error(error?.response?.data?.msg || 'An error occurred');
      },
    }
  );

  //------- Commission Modal -------
  const {
    isLoading: staffCommissionLoading,
    mutate: staffCommissionMutate,
  } = useMutation(
    (payload) =>
      axios.post(`${Config.apiUrl}/staff-commission/add`, payload, {
        headers: {
          authorization: `Bearer ${user.token}`,
        },
      }),
    {
      onSettled: () => {
        setIsCommissionModal(false);
      },
      onSuccess: ({ data }) => {
        getListMutate();
        toast.success(data?.msg || 'Success');
      },
      onError: (error) => {
        toast.error(error?.response?.data?.msg || 'An error occurred');
      },
    }
  );

  //------- Commission Pay Modal -------
  const {
    isLoading: payCommissionLoading,
    mutate: payCommissionMutate,
  } = useMutation(
    (payload) =>
      axios.post(`${Config.apiUrl}/staff-commission/pay`, payload, {
        headers: {
          authorization: `Bearer ${user.token}`,
        },
      }),
    {
      onSettled: () => {
        setIsPayCommissionModal(false);
      },
      onSuccess: ({ data }) => {
        setIsViewCommissionModal(false)
        getListMutate();
        toast.success(data?.msg || 'Success');
      },
      onError: (error) => {
        toast.error(error?.response?.data?.msg || 'An error occurred');
      },
    }
  );

  //------- Initiate Transfer -------
  const InitTransferFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/due/settle/excess/after/eviction/online`, values, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${user.token}`,
      },
    });
  };

  const transferSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg);
      setShowOnlineRefundModal(false);
      setIsShowFinalDuesModal(false);
      getListMutate();
    } else {
      toast.error(data?.data?.msg);
    }
  };

  const transferError = (data) => {
    setShowOnlineRefundModal(false);
    setIsShowFinalDuesModal(false);
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: initTransferLoader, mutate: initTransferMutate } =
    useMutation(InitTransferFunction, {
      onSuccess: transferSuccess,
      onError: transferError,
    });

  const {
    verifyBankAccount,
    verifyAccountLoading,
    isAccountVerified,
    verifiedAccountName,
    verifyErrorMsg,
    clearVerification,
  } = useVerifyBankAccount(user.token);

  //------- Wifi Add Details -------
  const wifiDetailsFunction = async (values) => {
    return await axios.post(
      `${Config.apiUrl}/wifiCred/add`, values,
      {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${user.token}`,
        },
      },
    );
  };
  const wifiDetailsSuccess = (data) => {
    toast.success(data?.data?.msg || "Success");
    setIsWifiPassword(false);
    getListMutate()
  };

  const wifiDetailsError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: wifiDetailsLoading, mutate: wifiDetailsMutate } =
    useMutation(wifiDetailsFunction, {
      onSuccess: wifiDetailsSuccess,
      onError: wifiDetailsError,
    });
  //------- Wifi Edit Details -------
  const wifiEditDetailsFunction = async (values) => {
    return await axios.post(
      `${Config.apiUrl}/wifiCred/edit`, values,
      {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${user.token}`,
        },
      },
    );
  };
  const wifiEditDetailsSuccess = (data) => {
    toast.success(data?.data?.msg || "Success");
    setIsWifiPassword(false);
    getListMutate()
  };

  const wifiEditDetailsError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: wifiEditDetailsLoading, mutate: wifiEditDetailsMutate } =
    useMutation(wifiEditDetailsFunction, {
      onSuccess: wifiEditDetailsSuccess,
      onError: wifiEditDetailsError,
    });

  const fetchWifiListing = async () => {
    try {
      const response = await axios.get(
        `${Config.apiUrl}/wifiCred/list/for/client?tenantId=${tenantId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching WiFi data:", error);
      return null;
    }
  };

  // Update the handleWifiModalOpen function
  const handleWifiModalOpen = async (data) => {
    setIsWifiPassword(true);
    setSelectedData(data);
    // Fetch WiFi listing when modal opens
    const wifiData = await fetchWifiListing();
    setWifiListData(wifiData);
  };
  const handleWifiModalClose = () => {
    setIsWifiPassword(false);
  };


  return (
    <BoxContainer >
      <button
        type="button"
        onClick={() => navigate(-1)}
        className="flex items-center gap-1.5 mb-4 text-primary-color text-base
        font-normal hover:opacity-80 transition-opacity"
      >
        <FiArrowLeft size={20} />
        Back
      </button>
      {!error && !isLoading && data && (
        <Wrapper className='mt-2'>
          <CardContainer>
            <HeaderWrapper>
              {/* LEFT: Avatar + Info */}
              <ProfileWrapper>
                <AvatarWrapper>
                  <UserImage
                    src={selfi ? selfi : Images.Avatar}
                    alt={`Tenant Profile`}
                  />
                  {(apiData?.kycStatus === 5 || apiData?.kycStatus === 4) && (
                    <VerifiedBadge>
                      <FaCheck className="text-white" size={10} />
                    </VerifiedBadge>
                  )}
                </AvatarWrapper>
                <TenantInfos>
                  <NameWrapper>
                    <TenantName>
                      {capitalizeFirstLetter(
                        apiData?.name || "Unknown Tenant"
                      )}
                    </TenantName>
                    {getTenantState(e)}
                  </NameWrapper>
                  <TenantProp>
                    {apiData?.occupancy?.roomNum
                      ? `#${apiData.occupancy.roomNum}`
                      : 'N/A'},
                    {apiData?.occupancy?.flatName || "N/A"},{" "}
                    {apiData?.occupancy?.propName}
                  </TenantProp>
                </TenantInfos>
              </ProfileWrapper>
              {/* RIGHT: Actions */}
              {canSettleDues && (
                <ButtonWrapper>
                  {hasDues && (
                    <AddBtn
                      title={`Outstanding dues: ₹${data?.data?.totalDues}`}
                      onClick={() => setIsMarkAsPaidAllDue(true)}
                    >
                      Settle All Dues
                    </AddBtn>
                  )}

                  <AddDueBtn
                    onClick={() => setIsAddDuesModal(true)}
                    data-variant={hasDues ? 'secondary' : 'primary'}
                  >
                    Add Dues
                  </AddDueBtn>
                </ButtonWrapper>
              )}
            </HeaderWrapper>

            {/* ================= BODY ================= */}
            <CardBody>
              <InfoGrid>
                <InfoItem>
                  <InfoLabel>
                    Tenant Id
                  </InfoLabel>
                  <InfoValue>#{apiData?.tId || "N/A"}</InfoValue>
                </InfoItem>

                <InfoItem>
                  <InfoLabel>
                    Rent
                  </InfoLabel>
                  <InfoValue>₹{apiData?.occupancy?.rent}</InfoValue>
                </InfoItem>

                <InfoItem>
                  <InfoLabel>
                    Total Collection
                  </InfoLabel>
                  <CollectionValue
                    onClick={() => {
                      setGoto("totalTransaction");
                      setActiveStep("Passbook");
                    }}
                  >
                    ₹{data?.data?.totalCollection || 0}
                  </CollectionValue>
                </InfoItem>

                <InfoItem>
                  <InfoLabel>
                    Total Dues
                  </InfoLabel>
                  <DuesValue
                    onClick={() => {
                      setGoto("totalDues");
                      setActiveStep("Passbook");
                    }}
                  >
                    ₹{data?.data?.totalDues || 0}
                  </DuesValue>
                </InfoItem>

                {/* {apiData?.occupancy?.discount !== 0 && ( */}
                {apiData?.occupancy?.discount != null &&
                  apiData?.occupancy?.discount !== 0 && (
                    <InfoItem>
                      <InfoLabel>
                        {/* <MdDiscount className="w-4 h-4" /> */}
                        Discount
                      </InfoLabel>
                      <DiscountValue>
                        {apiData?.occupancy?.discountType === 1
                          ? `₹${apiData?.occupancy?.discount}`
                          : `${apiData?.occupancy?.discount}%`}{" "}
                        /
                        <span className="text-sm text-gray-900 font-normal">
                          cycle
                        </span>
                        <DiscountPeriod>
                          {moment(apiData?.occupancy?.discountStartDate).format(
                            "MMM DD, YYYY"
                          )}{" "}
                          -{" "}
                          {moment(apiData?.occupancy?.discountEndDate).format(
                            "MMM DD, YYYY"
                          )}
                        </DiscountPeriod>
                      </DiscountValue>
                    </InfoItem>
                  )}
              </InfoGrid>
              <div className="mt-6 flex md:flex-row flex-col md:justify-between items-center">
                <div className="flex items-center gap-2 text-sm text-gray-600">
                  {/* <FiCalendar size={14} className="text-gray-400" /> */}
                  {!e && Config.OCCUPANCY_STATUS.MOVING_OUT !== apiData?.occupancy?.status && apiData?.occupancy?.stayType !== 2 && (
                    <div className="flex md:flex-row flex-col">
                      {apiData.lastRentPaid && (
                        <h1 className="text-xs text-gray-600">
                          Last rent paid on{" "}
                          {moment(apiData.lastRentPaid).format("MMM DD, YYYY")}.{" "}
                        </h1>
                      )}

                      <p className="text-xs text-gray-600 ml-1">
                        Next rent will be generated on{" "}
                        {getOrdinalNumber(apiData.occupancy.rentalCycle)} of the
                        month.
                      </p>
                    </div>
                  )}
                  {(e || Config.OCCUPANCY_STATUS.MOVING_OUT === apiData?.occupancy?.status) && apiData?.occupancy?.stayType !== 2 && (
                    <div className="flex md:flex-row flex-col">
                      <h1 className="text-xs text-red-400">
                        {e && apiData?.occupancy?.wasCancelled === 1
                          ? "Cancelled reservation on "
                          : e
                            ? "Moved Out on "
                            : "Moving Out on "}

                        {moment(apiData?.occupancy?.moveOutDate).format("MMM DD, YYYY") + "."}
                      </h1>

                      <p className="text-xs text-red-400 ml-1">
                        {apiData?.occupancy?.moveOutReason ? "(" + getMoveOutReasonLabel(apiData?.occupancy?.moveOutReason) + ")" : "(End of Lease / Contract)"}
                      </p>
                    </div>
                  )}
                </div>
                <div>
                  {apiData?.occupancy?.status === Config.OCCUPANCY_STATUS.OCCUPIED && (
                    <button className="text-red-600 underline text-sm hover:text-red-700 whitespace-nowrap" onClick={() => setInitiateEviction(true)}>
                      Initiate Eviction
                    </button>
                  )}

                  {e == 1 && apiData?.occupancy?.wasCancelled !== 1 && (
                    apiData?.isRefunded === 1 ? (
                      <button
                        disabled={generateFnFQuery.isFetching}
                        className={`inline-flex items-center text-primary-color underline text-sm ${generateFnFQuery.isFetching ? "opacity-60 cursor-not-allowed" : ""
                          }`}
                        onClick={handleSubmitFinalDuesSummary}
                      >
                        {generateFnFQuery.isFetching ? (
                          <>
                            <FaSpinner className="animate-spin mr-2" size={14} />
                            Processing...
                          </>
                        ) : (
                          <>Full & Final Processed</>
                        )}
                      </button>
                    ) : (
                      <button
                        className="inline-flex items-center text-primary-color underline text-sm"
                        onClick={() => setIsShowFinalDuesModal(true)}
                      >
                        {apiData?.isRefunded === 2 ? "Full & Final Summary" : apiData?.isRefunded === 3 ? "" : "Initiate Full & Final"}
                      </button>
                    )
                  )}

                  {apiData?.occupancy?.status === Config.OCCUPANCY_STATUS.MOVING_OUT && (
                    <button
                      className="text-sm text-red-600 hover:text-red-700 underline whitespace-nowrap"
                      onClick={() => {
                        setIsEvictNow(true);
                        setSelectedData(data);
                      }}
                    >
                      Evict Now
                    </button>
                  )}
                  {apiData?.occupancy?.status === Config.OCCUPANCY_STATUS.RESERVED && (
                    <button
                      className="text-sm text-red-600 hover:text-red-700 underline whitespace-nowrap"
                      onClick={() => {
                        setSelectedData(data);
                        setIsCancelReservation(true);
                      }}
                    >
                      Cancel Reservation
                    </button>
                  )}
                </div>
              </div>
            </CardBody>
          </CardContainer>

          <SideModal
            isOpen={isShowFinalDuesModal}
            onClose={() => setIsShowFinalDuesModal(false)}
          >
            <ViewFinalDues
              setIsShowFinalDuesModal={setIsShowFinalDuesModal}
              markAsPaidMutate={markAsPaidMutate}
              dueListData={dueListData}
              dueListLoading={dueListLoading}
              dueListError={dueListError}
              dueListReftech={dueListReftech}
              apiData={apiData}
              editDueLoading={editDueLoading}
              editDueMutate={editDuesMutate}
              tenantId={tenantId}
              onSubmit={handleSubmitFinalDues}
              isGenerating={generateFnFQuery.isFetching}
              setIsAddDuesModal={setIsAddDuesModal}
              setShowOfflineRefundModal={setShowOfflineRefundModal}
              setShowOnlineRefundModal={setShowOnlineRefundModal}
              getListMutate={getListMutate}
            />
          </SideModal>

          <SideModal
            isOpen={isMarkAsPaidVisible}
            onClose={() => setIsMarkAsPaidVisible(false)}
          >
            <MarkAsPaidModal
              setIsMarkAsPaidVisible={setIsMarkAsPaidVisible}
              markAsPaidMutate={markAsPaidMutate}
              markAsPaidLoading={markAsPaidLoading}
              isMarkAsPaidVisible={isMarkAsPaidVisible}
              selectedData={selectedData}
              setSelectedData={setSelectedData}
              isEvicted={e ? true : false}
              bankAccount={apiData?.bankAccounts}
              securityRemaining={apiData?.securityRemaining}
            />
          </SideModal>

          <SideModal
            isOpen={isMarkAsPaidAllDue}
            onClose={() => setIsMarkAsPaidAllDue(false)}
          >
            <MarkAsPaidAllDue
              setIsMarkAsPaidAllDue={setIsMarkAsPaidAllDue}
              markAsPaidAllDueMutate={markAsPaidAllDueMutate}
              markAsPaidAllDueLoading={markAsPaidAllDueLoading}
              isMarkAsPaidAllDue={isMarkAsPaidAllDue}
              selectedData={selectedData}
              setSelectedData={setSelectedData}
              isEvicted={e ? true : false}
              data={data}
            />
          </SideModal>

          <SideModal
            isOpen={showOfflineRefundModal}
            onClose={() => setShowOfflineRefundModal(false)}
            level="high"
            width={isShowFinalDuesModal ? "1/3" : undefined}
          >
            <OfflineRefundModal
              setShowOfflineRefundModal={setShowOfflineRefundModal}
              returnDepositMutate={returnDepositMutate}
              returnDepositLoading={returnDepositLoading}
              isEvicted={e ? true : false}
              //data={data}
              data={{
                //data: data,
                tenantId: data?.data?.id,
                tenantName: data?.data?.name,
                tenantMobile: data?.data?.mobile,
                refundAmount: data?.data?.refundAmount,
                propAddress: (data?.data?.occupancy?.roomNum) + ", " + (data?.data?.occupancy?.flatName) + ", " + (data?.data?.occupancy?.propName),
                selfi: selfi,
                excessBalance: data?.data?.excessBalance
              }
              }
              finalDueRefund={dueListData?.data?.data?.totalRefund}
            />
          </SideModal>

          <SideModal
            isOpen={showOnlineRefundModal}
            onClose={() => setShowOnlineRefundModal(false)}
            level="high"
            width={isShowFinalDuesModal ? "1/3" : undefined}
          >
            <OnlineRefundModal
              setShowOnlineRefundModal={setShowOnlineRefundModal}
              initTransferMutate={initTransferMutate}
              initTransferLoader={initTransferLoader}
              verifyAccountLoading={verifyAccountLoading}
              verifyBankAccount={verifyBankAccount}
              isAccountVerified={isAccountVerified}
              verifiedAccountName={verifiedAccountName}
              clearVerification={clearVerification}
              verifyErrorMsg={verifyErrorMsg}
              data={{
                tenantId: data?.data?.id,
                tenantName: data?.data?.name,
                tenantMobile: data?.data?.mobile,
                refundAmount: data?.data?.refundAmount,
                accountDetail: data?.data?.account,
                propId: data?.data?.occupancy?.propId,
                propAddress: (data?.data?.occupancy?.roomNum) + ", " + (data?.data?.occupancy?.flatName) + ", " + (data?.data?.occupancy?.propName),
                selfi: selfi,
                payoutBalance: data?.data?.payoutBalance || 0,
                refundStatus: data?.data?.occupancy?.refundStatus
              }
              }
              finalDueRefund={dueListData?.data?.data?.totalRefund}
            />
          </SideModal>

          <SideModal
            isOpen={isAddDuesModal}
            onClose={() => setIsAddDuesModal(false)}
            level="high"
            width={isShowFinalDuesModal ? "1/3" : undefined}
          >
            <AddDuesModal
              setIsAddDuesModal={setIsAddDuesModal}
              addDuesMutate={addDuesMutate}
              addDuesLoading={addDuesLoading}
              isAddDuesModal={isAddDuesModal}
              tenantId={tenantId}
              data={data}
              rentStartDate={rentStartDate}
              setIsShowFinalDuesModal={setIsShowFinalDuesModal}
              isShowFinalDuesModal={isShowFinalDuesModal}
              advanceRentSlots={apiData?.advanceRentSlots || []}
              initiateEvictionFlow={(apiData?.occupancy?.status === Config.OCCUPANCY_STATUS.MOVING_OUT || e === '1') ? true : false}
              isEvicted={e ? true : false}
            />
          </SideModal>

          <SideModal
            isOpen={initiateEviction}
            onClose={() => setInitiateEviction(false)}
            level="base"

          >
            <InitiateTenantEviction
              // setIsAddDuesModal={setIsAddDuesModal}
              setInitiateEviction={setInitiateEviction}
              apiData={apiData}
              selfi={selfi}
              tenantId={tenantId}
              data={data}
              rentStartDate={rentStartDate}
              refresh={getListMutate}
            />
          </SideModal>

          <SideModal
            isOpen={isChangeRoom}
            onClose={() => setIsChangeRoom(false)}
          >
            <ChangeRoom
              setIsChangeRoom={setIsChangeRoom}
              data={data?.data}
              property={property}
              selfi={selfi}
            />
          </SideModal>
          <SideModal
            isOpen={isViewNotes}
            onClose={() => setIsViewNotes(false)}
          >
            <Notes
              isViewNotes={isViewNotes}
              setIsViewNotes={setIsViewNotes}
              selectedData={selectedData}
            />
          </SideModal>

          {isRentalCycle && (
            <ChangeRentalCycle
              setIsRentalCycle={setIsRentalCycle}
              selectedData={selectedData}
              setSelectedData={setSelectedData}
              changeRentalCycleLoading={changeRentalCycleLoading}
              changeRentalCycleMutate={changeRentalCycleMutate}
            />
          )}
          {isRestorePayment && (
            <RestorePayment
              setIsRestorePayment={setIsRestorePayment}
              selectedData={selectedData}
              restorePaymentLoading={restorePaymentLoading}
              restorePaymentMutate={restorePaymentMutate}
            />
          )}
          {isEditDue && (
            <EditDuesModel
              editDuesMutate={editDuesMutate}
              editDueLoading={editDueLoading}
              setIsEditDues={setIsEditDues}
              canHideDue={canHideDues}
              data={data?.data}
              selectedData={selectedData}
              hideDueMutate={hideDueMutate}
              hideDueLoading={hideDueLoading}
              canHideDues={canHideDues}
              e={e}
            />
          )}

          <SideModal
            isOpen={isShowDueDetails}
            onClose={() => setShowDueDetails(false)}
          >
            <ViewDueDetails
              setShowDueDetails={setShowDueDetails}
              selectedData={selectedData}
              setIsEditDues={setIsEditDues}
              showNotesModal={showNotesModal}
              setShowNotesModal={setShowNotesModal}
              addEditRemarkMutate={addEditRemarkMutate}
              addEditRemarkLoading={addEditRemarkLoading}
              canEditDues={canSettleDues}
            />
          </SideModal>

          {isEvictNow && (
            <EvictNowModal
              setIsEvictNow={setIsEvictNow}
              evictNowLoading={evictNowLoading}
              evictNowMutate={evictNowMutate}
              selectedData={selectedData}
            />
          )}
          {isCancelEviction && (
            <CancelEviction
              setIsCancelEviction={setIsCancelEviction}
              cancelEvictionLoading={cancelEvictionLoading}
              cancelEvictionMutate={cancelEvictionMutate}
              selectedData={selectedData}
            />
          )}
          {isDeleteTenantModal && (
            <DeleteTenantModal
              setIsDeleteTenantModal={setIsDeleteTenantModal}
              deleteTenantLoading={deleteTenantLoading}
              deleteTenantMutate={deleteTenantMutate}
              selectedData={selectedData}
              e={e}
            />
          )}
          {isChangeOccupancy && (
            <ChangeOccupancyModal
              setIsChangeOccupancy={setIsChangeOccupancy}
              changeOccupancyLoading={changeOccupancyLoading}
              changeOccupancyMutate={changeOccupancyMutate}
              selectedData={selectedData}
            />
          )}
          {isEntireOccupancy && (
            <EntireRoomOccupancy
              setIsEntireOccupancy={setIsEntireOccupancy}
              entireRoomOccupancyLoading={entireRoomOccupancyLoading}
              entireRoomOccupancyMutate={entireRoomOccupancyMutate}
              selectedData={selectedData}
            />
          )}
          {isCancelReservation && (
            <CancelReservation
              setIsCancelReservation={setIsCancelReservation}
              cancelReservationLoading={cancelReservationLoading}
              cancelReservationMutate={cancelReservationMutate}
              selectedData={selectedData}
            />
          )}

          <SideModal
            isOpen={isExtendStay}
            onClose={() => setIsExtendStay(false)}
          >
            <ExtendStay
              setIsExtendStay={setIsExtendStay}
              selectedData={selectedData}
              extendStayLoading={extendStayLoading}
              extendStayMutate={extendStayMutate}
              handleClose={handleExtendStayClose}
            />
          </SideModal>

          <SideModal isOpen={viewDetail} onClose={() => setViewDetail(false)}>
            <ViewModal
              setViewDetail={setViewDetail}
              selectedData={selectedData}
            />
          </SideModal>
          <SideModal
            isOpen={isReassignTenant}
            onClose={() => setIsReassignTenant(false)}
          >
            <ReassignTenant
              setIsReassignTenant={setIsReassignTenant}
              isReassignTenant={isReassignTenant}
              handleClose={handleReassignClose}
              selectedData={selectedData}
              reassignTenantLoading={reassignTenantLoading}
              reassignTenantMutate={reassignTenantMutate}
              tenantId={tenantId}
            />
          </SideModal>

          <SideModal
            isOpen={isCommissionModal}
            onClose={() => setIsCommissionModal(false)}
          >
            <AddCommission
              setIsCommissionModal={setIsCommissionModal}
              isCommissionModal={isCommissionModal}
              handleClose={handleCommissionModal}
              staffCommissionLoading={staffCommissionLoading}
              staffCommissionMutate={staffCommissionMutate}
              tenantId={tenantId}
              data={data?.data}
            />
          </SideModal>

          <SideModal
            isOpen={isViewCommissionModal}
            onClose={() => setIsViewCommissionModal(false)}
          >
            <ViewCommissionModal
              setIsViewCommissionModal={setIsViewCommissionModal}
              isViewCommissionModal={isViewCommissionModal}
              handleClose={handleViewCommissionModal}
              selectedData={selectedData}
              setSelectedStaff={setSelectedStaff}
              setIsPayCommissionModal={setIsPayCommissionModal}
            />
          </SideModal>

          <SideModal
            isOpen={isPayCommissionModal}
            onClose={() => setIsPayCommissionModal(false)}
            width="1/3"
            level="high"
          >
            <MarkAsPaidStaffCommission
              isPayCommissionModal={isPayCommissionModal}
              setIsPayCommissionModal={setIsPayCommissionModal}
              handleClose={handlePayCommissionModal}
              payCommissionLoading={payCommissionLoading}
              payCommissionMutate={payCommissionMutate}
              selectedStaff={selectedStaff}

            />
          </SideModal>

          <SideModal
            isOpen={isWifiPassword}
            // onClose={handleWifiModalClose}
            onClose={() => {
              setIsWifiPassword(false);
              setWifiListData(null);
            }}
          >
            <WifiPasswordModal
              setIsWifiPassword={setIsWifiPassword}
              isWifiPassword={isWifiPassword}
              wifiDetailsMutate={wifiDetailsMutate}
              wifiDetailsLoading={wifiDetailsLoading}
              selectedData={selectedData}
              // handleDetailModalClose={handleWifiModalClose}
              handleDetailModalClose={() => {
                setIsWifiPassword(false);
                setWifiListData(null);
              }}
              tenantId={tenantId}
              wifiEditDetailsLoading={wifiEditDetailsLoading}
              wifiEditDetailsMutate={wifiEditDetailsMutate}
              wifiListData={wifiListData}
            />
          </SideModal>

          <Card className="mt-6">
            <FieldWrapper>

              <div className="mx-auto flex justify-between px-4">
                <FloorTabs >
                  {steps.map((step) => {
                    const isActive = activeStep === step;

                    return (
                      <button
                        key={step}
                        onClick={() => handleButtonClick(step)}
                        className={`relative px-1 py-3 text-sm whitespace-nowrap transition-colors duration-200
                          ${isActive
                            ? "text-zinc-900 font-semibold"
                            : "text-zinc-500 font-normal hover:text-zinc-700"
                          }
                        `}
                      >
                        {step}

                        {isActive && (
                          <span className="absolute left-0 bottom-0 w-full h-[2px] bg-zinc-900 rounded-full transition-all duration-200" />
                        )}
                      </button>
                    );
                  })}
                </FloorTabs>
                <Menu
                  setInitiateEviction={setInitiateEviction}
                  data={data}
                  setIsCancelEviction={setIsCancelEviction}
                  setIsCancelReservation={setIsCancelReservation}
                  setIsExtendStay={setIsExtendStay}
                  setIsEvictNow={setIsEvictNow}
                  selectedData={selectedData}
                  setSelectedData={setSelectedData}
                  setIsChangeRoom={setIsChangeRoom}
                  setIsRentalCycle={setIsRentalCycle}
                  setIsReassignTenant={setIsReassignTenant}
                  isReassignTenant={isReassignTenant}
                  e={e}
                  setIsDeleteTenantModal={setIsDeleteTenantModal}
                  setIsViewNotes={setIsViewNotes}
                  setIsChangeOccupancy={setIsChangeOccupancy}
                  setIsCommissionModal={setIsCommissionModal}
                  setIsViewCommissionModal={setIsViewCommissionModal}
                  setIsEntireOccupancy={setIsEntireOccupancy}
                  setIsWifiPassword={setIsWifiPassword}
                  onWifiClick={handleWifiModalOpen}
                />
              </div>

              <div className="flex flex-wrap md:flex-nowrap gap-6 px-4 py-4 overflow-y-auto">
                <div className="w-full">
                  {activeStep === "Tenant Info" && (
                    <>
                      <TenantInfo
                        data={apiData}
                        editRentDetailMutate={editRentDetailMutate}
                        editPersonalDetailMutate={editPersonalDetailMutate}
                        addGuardianDetailMutate={addGuardianDetailMutate}
                        editOccupationDetailMutate={editOccupationDetailMutate}
                        isRentDetailLoading={isRentDetailLoading}
                        isPersonalDetailLoading={isPersonalDetailLoading}
                        isGuardianDetailLoading={isGuardianDetailLoading}
                        isOccupationDetailLoading={isOccupationDetailLoading}
                        e={e ? true : false}
                      />
                    </>
                  )}

                  {activeStep === "Passbook" && (
                    <>
                      <Passbook
                        data={apiData}
                        goTo={goTo}
                        setIsMarkAsPaidVisible={setIsMarkAsPaidVisible}
                        setSelectedData={setSelectedData}
                        selectedData={selectedData}
                        setShowDueDetails={setShowDueDetails}
                        sendReminderMutate={sendReminderMutate}
                        setIsRestorePayment={setIsRestorePayment}
                        setViewDetail={setViewDetail}
                        e={e}
                        canMarkPaymentPaid={canSettleDues}
                        loadPaymentLinkModal={loadPaymentLinkModal}
                        loadingId={loadingId}
                        setIsReturnDeposit={setIsReturnDeposit}
                        hideDueMutate={hideDueMutate}
                        hideDueLoading={hideDueLoading}
                        setHideLoadingId={setHideLoadingId}
                        hideLoadingId={hideLoadingId}
                        setIsViewNotes={setIsViewNotes}
                      />
                    </>
                  )}

                  {activeStep === "Documents" && (
                    <>
                      <Documents
                        docs={docs}
                        setShowUploadModel={setShowUploadModel}
                        showUploadModel={showUploadModel}
                        uploadDocMutate={uploadDocMutate}
                        isDocLoading={isDocLoading}
                      />
                    </>
                  )}

                  {activeStep === "Activity Logs" && (
                    <>
                      <ActivityLogs
                        tenantId={tenantId}
                      />
                    </>
                  )}

                  {activeStep === "Ledger" && (
                    <>
                      <Ledger
                        tenantId={tenantId}
                        e={e}
                      />
                    </>
                  )}

                </div>
              </div>
            </FieldWrapper>
          </Card>

          <PaymentLinkModal
            isOpen={showPaymentLinkModal}
            onClose={() => setShowPaymentLinkModal(false)}
            paymentData={paymentData}
          />

          <FnFModal
            isOpen={showFnFModal}
            onClose={handleFnFClose}
            fnfData={fnfData}
            onSendToTenant={handleSendToTenant}
            isSending={sendFnFMutation.isPending}
            isGenerating={generateFnFQuery.isFetching}
            pdfError={generateFnFQuery.error?.message}
          />
        </Wrapper>
      )}
      {(isLoading || isRefetching) && <TenantDetailsLoading />}
    </BoxContainer>
  );
};


const FieldWrapper = tw.div`w-full`;
const Wrapper = tw.div`px-1`;
const Card = tw.div`p-3 rounded-lg bg-white shadow-sm`;
const InActive = tw.div`bg-red-50 text-red-700 text-xs font-medium px-2.5 w-auto h-6 flex items-center justify-center rounded-full`;
const Active = tw.div`bg-emerald-50 text-emerald-700 text-xs font-medium px-2.5 w-auto h-6 flex items-center justify-center rounded-full`;
const Reserved = tw.div`bg-blue-50 text-blue-700 text-xs font-medium px-2.5 w-auto h-6 flex items-center justify-center rounded-full`;
const CardContainer = tw.div`bg-white rounded-xl shadow-sm border border-gray-200/60 overflow-hidden`;
//const CardHeader = tw.div`bg-gradient-to-r from-gray-50 to-gray-100/50 px-6 py-5`;
const CardHeader = tw.div`px-6 py-5 border-b border-gray-100`;
const HeaderWrapper = tw.div`flex items-center justify-between gap-6 p-5 border-b border-gray-100`;
const ProfileWrapper = tw.div`flex items-center gap-4 z-index`;
const AvatarWrapper = tw.div`flex items-end w-12 h-12`;
const UserImage = tw.img`w-12 h-12 rounded-full shadow-lg`;
const VerifiedBadge = tw.div`rounded-full bg-emerald-500 p-1 flex items-center justify-center -ml-3.5`;
const TenantInfos = tw.div`flex-1 min-w-0`;
const NameWrapper = tw.div`flex items-center gap-3`;
const TenantName = tw.h2`text-md font-semibold text-gray-900 truncate`;
const TenantProp = tw.p`text-sm text-gray-500 truncate`;
const ButtonWrapper = tw.div`flex flex-col sm:flex-row gap-3 sm:justify-end`;
const CardBody = tw.div`p-5`;
const InfoGrid = tw.div`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6`;
const InfoItem = tw.div``;
const InfoLabel = tw.div`flex items-center gap-2 text-gray-500 text-sm`;
const InfoValue = tw.p`text-base font-semibold text-gray-900`;
const CollectionValue = tw(
  InfoValue
)`text-emerald-600 cursor-pointer hover:text-emerald-700 transition-colors`;
const DuesValue = tw(
  InfoValue
)`text-red-600 cursor-pointer hover:text-red-600 transition-colors`;
const DiscountValue = tw(InfoValue)`text-gray-900`;
const DiscountPeriod = tw.span`text-xs font-normal text-gray-900 flex items-center`;
// const AddBtn = tw.button`${(p) =>
//   p.$active
//     ? "bg-gray-100"
//     : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6  cursor-pointer bg-primary-color hover:bg-hover-color  py-2.5 text-sm`;
// const AddDueBtn = tw.button`${(p) =>
//   p.$active
//     ? "bg-gray-100"
//     : ""} border whitespace-nowrap border-primary-color flex space-x-1.5 justify-center items-center text-primary-color h-full rounded-md px-6  cursor-pointer bg-white hover:bg-hover-color  py-2.5 text-sm `;
const AddDueBtn = tw.button`
  text-white
  bg-gradient-to-r from-primary-color to-[#00A0FF] hover:brightness-110
  px-4 py-2 rounded-md text-sm font-medium
`;

const AddBtn = tw.button`
  bg-white text-primary-color
  border border-primary-color
  hover:bg-primary-color/5 font-medium
  px-4 py-2 rounded-md text-sm
`;

const TenantBookedBy = tw.div`text-xs text-gray-500`;
const BookedByBadge = tw.div`
  bg-blue-50 text-blue-600 text-[10px] 
  px-2.5 h-6 flex items-center justify-center 
  rounded-full border border-blue-200
  hover:bg-blue-100 transition-colors
`;

export default TenantDetails;
